import React from "react";
import api from "../../api";
import { useAppSettings } from "../../core/hooks/useAppSettings";
import brandLogo from "./Cityinfo-logo.png";

const BrandLogo: React.FunctionComponent<{ className?: string }> = (props) => {
  const settings = useAppSettings(api.settings);
  // if (!settings.data) {
  //   return <></>;
  // }
  // const getLogo = () => {
  //   try {
  //     return require(`./Cityinfo-logo.png`);
  //   } catch (e) {
  //     return undefined;
  //   }
  // };
  return (
    <img
      src={brandLogo}
      className={`img-fluid ${props.className || ""}`}
      alt={settings.data?.franchiseName}
    />
  );
};

export default BrandLogo;
